// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/mdi/css/materialdesignicons.css
// module id = 1
// module chunks = 0